var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0001 1.13037C7.15888 1.13073 6.32603 1.2973 5.54939 1.62053C4.77276 1.94375 4.06764 2.41725 3.47456 3.01382C2.27333 4.2221 1.59939 5.85686 1.6001 7.56065C1.6001 9.60323 2.12884 11.0891 4.16145 13.5789C5.10571 14.6523 5.93306 15.8232 6.62951 17.0718C7.3665 18.573 7.27961 19.5919 8.0001 19.5919C8.72059 19.5919 8.6337 18.573 9.37068 17.0718C10.0671 15.8232 10.8945 14.6523 11.8387 13.5789C13.8714 11.0891 14.4001 9.60311 14.4001 7.56065C14.4008 5.85686 13.7268 4.22211 12.5256 3.01382C11.9326 2.41725 11.2274 1.94375 10.4508 1.62053C9.67416 1.2973 8.84131 1.13073 8.0001 1.13037Z",
    fill: "white",
    fillOpacity: 0.01,
    stroke: "url(#paint0_linear_231_14454)",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00011 9.99241C9.35958 9.99241 10.4617 8.89034 10.4617 7.53087C10.4617 6.1714 9.35958 5.06934 8.00011 5.06934C6.64064 5.06934 5.53857 6.1714 5.53857 7.53087C5.53857 8.89034 6.64064 9.99241 8.00011 9.99241Z",
    fill: "white",
    fillOpacity: 0.01,
    stroke: "url(#paint1_linear_231_14454)",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_231_14454",
    x1: 8.0001,
    y1: 10.7304,
    x2: 8.0001,
    y2: 19.5919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01B0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E2688"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_231_14454",
    x1: 8.00005,
    y1: 7.53066,
    x2: 8.00011,
    y2: 9.99241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01B0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E2688"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.9250aeb9a3b861e6189f2c97c7a348d7.svg";
export { ForwardRef as ReactComponent };